import { createFileRoute } from "@tanstack/react-router";
import { LoginCard } from "@/projects/components/login-card";

export const Route = createFileRoute("/login/teacher")({
  head: () => ({ meta: [{ title: "Teacher Login — રાજનગર જ્ઞાનોત્સવ 2.0" }] }),
  component: () => <LoginCard role="teacher" />,
});
